window.googletag = window.googletag || {};
window.googletag.cmd = window.googletag.cmd || [];
window.siteData = window.siteData || {};

(function() {
    if (siteData && siteData.adslotsDisabled == true) {
        console.log('GPT not loaded since dataslots are disabled');
    } else {
        var gads = document.createElement("script");
        gads.async = true;
        gads.type = "text/javascript";
        var useSSL = "https:" == document.location.protocol;
        gads.src = (useSSL ? "https:" : "http:") +
            "//www.googletagservices.com/tag/js/gpt.js";
        var node = document.getElementsByTagName("script")[0];
        node.parentNode.insertBefore(gads, node);
    }
})();
